import React from "react";

import "./PrivacyPolicyContent.module.scss";

export const PrivacyPolicyContent = () => {
  return (
    <div className="privacy-policy-content">
      <h1>Piroshky Bakery Privacy Policy</h1>
      <h2>EFFECTIVE DATE: February 2, 2024</h2>
      <p>
        Piroshky Piroshky (“Piroshky Piroshky,” “Company,” “we,” or “us”) values
        your privacy. We offer a wide array of Piroshkies which are hand held
        pies that blend traditional recipes with the taste of the Pacific
        Northwest.
      </p>

      <p>
      &nbsp;
      </p>

      <p className="MsoNormal">
        In this Privacy Policy (“Policy”), we describe how we collect, use, and
        disclose information that we obtain about users of our website,
        www.piroshkybakery.com (the “Site”), and the products and services available
        through our Site (“Services”). By visiting the Site or otherwise using our
        Services, you agree that your information will be handled as described in
        this Policy. Your use of our Services is conditional upon your acceptance of
        and compliance with this Policy, and any dispute over privacy, is subject to
        this Policy and our&nbsp;
        <a
          aria-label="Go to Terms & Conidtion Page"
          href="https://piroshkybakery.com/policy-center/terms-and-conditions/"
          target="a"
        >
          Terms & Conditions
        </a>
        , including its applicable limitations on damages and the resolution of
        disputes. Our&nbsp;
        <a
          aria-label="Go to Terms & Conidtion Page"
          href="https://piroshkybakery.com/policy-center/terms-and-conditions/"
          target="a"
        >
          Terms & Conditions
        </a>
        &nbsp;are incorporated by reference into this Policy. If you disagree with
        any part of this Policy, then you do not have our permission to access or
        use the Website.
      </p>
      <h2>Your Rights</h2>
      <p className="MsoNormal">
        All visitors or users of this website have the following rights with regard
        to their personal information:
      </p>
      <ul style={{ marginTop: "0in" }} type="disc">
        <li className="MsoNormal" style={{ marginBottom: "0in" }}>
          The right to know what personal information has been collected about you,
          how it is used, and to whom it was disclosed or sold in the 12 months
          preceding the request;
        </li>
        <li className="MsoNormal" style={{ marginBottom: "0in" }}>
          The right to access that information free of charge or to request deletion
          of all or some of that information under certain circumstances
          <span className="msoIns">
            <ins cite="mailto:Katie%20Robinson" dateTime="2023-05-12T11:51">
              ;
            </ins>
          </span>
        </li>
        <li className="MsoNormal" style={{ marginBottom: "0in" }}>
          The right to correct inaccurate personal information;
        </li>
        <li className="MsoNormal" style={{ marginBottom: "0in" }}>
          The right to opt out of the sale or sharing of your personal information;{" "}
        </li>
        <li className="MsoNormal" style={{ marginBottom: "0in" }}>
          The right to ask us to transmit your personal information that we have
          collected on you to another provider (where technically feasible);
        </li>
        <li className="MsoNormal" style={{ marginBottom: "0in" }}>
          The right to receive the personal information that we hold about you in a
          portable and, to the extent feasible, a readily usable format that allows
          you to transmit this information to another entity;
        </li>
        <li className="MsoNormal" style={{ marginBottom: "0in" }}>
          The right to equal service and price and to not receive discriminatory
          treatment for exercising your privacy rights; and
        </li>
        <li className="MsoNormal" style={{ marginBottom: "0in" }}>
        The right to limit use
          and disclosure of sensitive personal information.
        </li>
      </ul>
      <p
        className="MsoNormal"
        style={{ marginBottom: "0in", textAlign: "justify", lineHeight: "normal" }}
      >
        &nbsp;
      </p>
      <p
        className="MsoNormal"
        style={{ marginBottom: "0in", textAlign: "justify", lineHeight: "normal" }}
      >
        If you would like to exercise any of your rights under the CPRA, please see
        the “Exercising Your Rights” section below
      </p>
      <p
        className="MsoNormal"
        style={{ marginBottom: "0in", textAlign: "justify", lineHeight: "normal" }}
      >
        &nbsp;
      </p>
      <h2>Information Collected, Disclosed, or Sold</h2>
      
      <p className="MsoNormal">
        We collect information directly from you, from non-affiliated entities, and
        by automated means as set out below. The type of information that we collect
        from you depends on your particular interaction with our Services, which
        includes the below information. We do not collect, disclose, or sell the
        personal information of consumers we actually know are less than 16 years of
        age.{" "}
      </p>
      <p>&nbsp;</p>
      <table
        className="MsoNormalTable"
        border={1}
        cellSpacing={0}
        cellPadding={0}
        width={625}
        style={{
          width: "468.4pt",
          background: "white",
          borderCollapse: "collapse",
          border: "none"
        }}
      >
        <thead>
          <tr>
            <td
              valign="bottom"
              style={{
                borderTop: "none",
                borderLeft: "solid #DDDDDD 1.0pt",
                borderBottom: "solid #DDDDDD 1.5pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "16.5pt", lineHeight: "normal" }}
              >
                <b>
                  <span style={{ color: "#343434" }}>Category of information</span>
                </b>
              </p>
            </td>
            <td
              valign="bottom"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.5pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "16.5pt", lineHeight: "normal" }}
              >
                <b>
                  <span style={{ color: "#343434" }}>
                    Specific piece of information
                  </span>
                </b>
              </p>
            </td>
            <td
              valign="bottom"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.5pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "16.5pt", lineHeight: "normal" }}
              >
                <b>
                  <span style={{ color: "#343434" }}>
                    Where we get this information
                  </span>
                </b>
              </p>
            </td>
            <td
              valign="bottom"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.5pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "16.5pt", lineHeight: "normal" }}
              >
                <b>
                  <span style={{ color: "#343434" }}>
                    How we use this information
                  </span>
                </b>
              </p>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "16.5pt", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Identifying information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "16.5pt", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Name</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Information submitted by the consumer.
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Marketing and advertising;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Performing services;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Processing or fulfilling orders or transactions;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Processing payments;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Providing customer service;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Verifying customer information.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Identifying information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Postal / Shipping address</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Information submitted by the consumer.
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Marketing and advertising;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Performing services;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Processing or fulfilling orders or transactions;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Processing payments;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Providing customer service;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Verifying customer information.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Identifying information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Billing address</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Information submitted by the consumer.
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Marketing and advertising;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Performing services;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Processing or fulfilling orders or transactions;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Processing payments;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Providing customer service;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Verifying customer information.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Identifying information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Phone number</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Information submitted by the consumer.
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Marketing and advertising;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Performing services;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Processing or fulfilling orders or transactions;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Providing customer service;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Verifying customer information.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Identifying information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>IP address</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  The observation and recording of activities by the business, such
                  as through the use of cookies.
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Analytics.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Identifying information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Email address</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Information submitted by the consumer.
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Marketing and advertising;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Performing services;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Processing or fulfilling orders or transactions;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Processing payments;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Providing customer service;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Verifying customer information.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Financial information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>
                  Credit card or debit card number
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Information submitted by the consumer.
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Performing services;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Processing or fulfilling orders or transactions;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Processing payments;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Resolving disputes.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Financial information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Card expiration date</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Information submitted by the consumer.
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Performing services;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Processing or fulfilling orders or transactions;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Processing payments;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Resolving disputes.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Financial information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Card CVV (security code)</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Information submitted by the consumer.
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Performing services;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Processing or fulfilling orders or transactions;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Processing payments;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Resolving disputes.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>
                  Internet or other electronic activity
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Browsing history</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Tracking pixels;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  The observation and recording of activities by the business, such
                  as through the use of cookies.
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Analytics;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Marketing and advertising;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Targeted advertising;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Verifying position and quality of ad impressions.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>
                  Internet or other electronic activity
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>
                  Information regarding your interaction with our website or
                  application
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Tracking pixels;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  The observation and recording of activities by the business, such
                  as through the use of cookies.
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Analytics;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Marketing and advertising;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Targeted advertising;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Verifying position and quality of ad impressions.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>
                  Internet or other electronic activity
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>
                  Information regarding your interactions with advertisements
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Tracking pixels;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  The observation and recording of activities by the business, such
                  as through the use of cookies.
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Analytics;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Marketing and advertising;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Targeted advertising;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Verifying position and quality of ad impressions.
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>
                  Sensitive personal information
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p
                className="MsoNormal"
                style={{ marginBottom: "0in", lineHeight: "normal" }}
              >
                <span style={{ color: "#343434" }}>Geolocation information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  The observation and recording of activities by the business, such
                  as through the use of cookies.
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul type="disc">
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Analytics;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Marketing and advertising;
                </li>
                <li
                  className="MsoNormal"
                  style={{ color: "#343434", lineHeight: "normal" }}
                >
                  Targeted advertising.
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>

      <h2>Purposes of Collection of Personal Information</h2>
      <p className="MsoNormal">
        We use your information, including personal information, for the following
        purposes:
      </p>
      <p>&nbsp;</p>
      <table
        className="MsoNormalTable"
        border={1}
        cellSpacing={0}
        cellPadding={0}
        width={625}
        style={{
          width: "468.4pt",
          background: "white",
          borderCollapse: "collapse",
          border: "none"
        }}
      >
        <thead>
          <tr>
            <td
              valign="bottom"
              style={{
                borderTop: "none",
                borderLeft: "solid #DDDDDD 1.0pt",
                borderBottom: "solid #DDDDDD 1.5pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <b>Category of personal information shared</b>
              </p>
            </td>
            <td
              valign="bottom"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.5pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <b>
                  <span style={{ color: "black" }}>
                    Specific piece of personal information shared
                  </span>
                </b>
              </p>
            </td>
            <td
              valign="bottom"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.5pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <b>
                  <span style={{ color: "black" }}>
                    Categories of third parties with whom personal information
                    is/was shared
                  </span>
                </b>
              </p>
            </td>
            <td
              valign="bottom"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.5pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <b>
                  <span style={{ color: "black" }}>Reasons for sharing</span>
                </b>
              </p>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Identifying information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Name</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    Customer management systems;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>Email marketing vendors;</span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    Financial transactions processors;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>Shipping companies</span>
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    To market to you via email;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    To manage our interactions with you;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>To process transactions.</span>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Identifying information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Postal / Shipping address</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    Customer management systems;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>Shipping companies</span>
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    To manage our interactions with you;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>To process transactions.</span>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Identifying information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Billing address</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    Customer management systems;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>Shipping companies</span>
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    To manage our interactions with you;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>To process transactions.</span>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Identifying information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Phone number</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    Customer management systems
                  </span>
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    To manage our interactions with you;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>To process transactions.</span>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Identifying information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>IP address</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>Data analytics providers</span>
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    To analyze your interactions with us or our website.
                  </span>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Identifying information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Email address</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    Customer management systems;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>Email marketing vendors;</span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    Financial transactions processors;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>Shipping companies</span>
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    To market to you via email;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    To manage our interactions with you;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>To process transactions.</span>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Financial information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>
                  Credit card or debit card number
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    Financial transactions processors
                  </span>
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>To process transactions.</span>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Financial information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Card expiration date</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    Financial transactions processors
                  </span>
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>To process transactions.</span>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Financial information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Card CVV (security code)</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    Financial transactions processors
                  </span>
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>To process transactions.</span>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>
                  Internet or other electronic activity
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Browsing history</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>Advertising networks;</span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>Data analytics providers</span>
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    To provide you with advertisements;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    To analyze your interactions with us or our website.
                  </span>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>
                  Internet or other electronic activity
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>
                  Information regarding your interaction with our website or
                  application
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>Advertising networks;</span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>Data analytics providers</span>
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    To provide you with advertisements;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    To analyze your interactions with us or our website.
                  </span>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>
                  Internet or other electronic activity
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>
                  Information regarding your interactions with advertisements
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>Advertising networks</span>
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    To analyze your interactions with us or our website;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    To provide you with advertisements.
                  </span>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>
                  Sensitive personal information
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <span style={{ color: "black" }}>Geolocation information</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>Advertising networks;</span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>Data analytics providers</span>
                </li>
              </ul>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <ul style={{ marginTop: "0in" }} type="disc">
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    To provide you with advertisements;
                  </span>
                </li>
                <li className="MsoNormal">
                  <span style={{ color: "black" }}>
                    To analyze your interactions with us or our website.
                  </span>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <p className="MsoNormal">&nbsp;</p>
      <h2>Analytics and Tracking</h2>
      <p className="MsoNormal">
        We and our third-party service providers use cookies, pixels, java script,
        and other tracking mechanisms to track information about your use of our
        Site, including Google Analytics. We may combine this information with other
        personal information we collect from you (and our third-party service
        providers may do so on our behalf). If you would like to opt out of Google
        Analytics, please visit{" "}
        <a 
        aria-label="Go to Google Cookie Policy Page"
        href="https://tools.google.com/dlpage/gaoptout/">
          https://tools.google.com/dlpage/gaoptout/
        </a>
        .
      </p>
      <p className="MsoNormal">
        <b>
          <i>Cookies.</i>
        </b>
        &nbsp;Cookies are alphanumeric identifiers that we transfer to your device’s
        hard drive through the Services for record-keeping purposes. Some cookies
        allow us to make it easier for you to navigate our Services, while others
        allow us to track your activities in our Services. For more information,
        please visit our Cookie policy located here:{" "}
        <a           
          aria-label="Go to Cookie Policy Page"
          href="https://piroshkybakery.com/policy-center/cookie-policy/">https://piroshkybakery.com/policy-center/cookie-policy/</a>
      </p>
      <p className="MsoNormal">
        <b>
          <i>Disabling Cookies.</i>
        </b>
        &nbsp;Most web browsers automatically accept cookies, but if you prefer, you
        can edit your browser options to block them in the future. The Help portion
        of the toolbar on most browsers will tell you how to prevent your computer
        from accepting new cookies, how to have the browser notify you when you
        receive a new cookie, or how to disable cookies altogether. These settings
        may prevent you from taking full advantage of the Site.
      </p>
      <p className="MsoNormal">
        <b>
          <i>Clear GIFs, pixel tags and other technologies. </i>
        </b>
        Clear GIFs are tiny graphics with a unique identifier, similar in function
        to cookies. In contrast to cookies, which are stored on your computer’s hard
        drive, clear GIFs are embedded invisibly on web pages. We may use clear GIFs
        (a.k.a. web beacons, web bugs or pixel tags), in connection with our Site
        to, among other things, track the activities of Site visitors, help us
        manage content, and compile statistics about Site usage. We and our
        third-party service providers also use clear GIFs in HTML emails to our
        customers, to help us track email response rates, identify when our emails
        are viewed, and track whether our emails are forwarded.
      </p>
      <p className="MsoNormal">
        <b>
          <i>Third Party Analytics.</i>
        </b>
        &nbsp;We may use non-affiliated analytics companies, for example Google
        Analytics (see privacy policy and opt-out) and Segment.io (see privacy
        policy), to evaluate use of our Services. We use these tools to help us
        understand use of, and to improve, our Services, performance, ad campaigns,
        and user experiences. These entities may use cookies and other tracking
        technologies, such as web beacons or local storage objects (LSOs), to
        perform their services.
      </p>
      <p className="MsoNormal">
        <b>
          <i>Do-Not-Track.</i>
        </b>
        &nbsp;Do Not Track is a preference you can set on your browser to inform
        websites that you do not want to be tracked. Currently, our systems do not
        recognize browser “do-not-track” requests. You may, however, disable certain
        tracking as discussed in this section (e.g., by disabling cookies).
      </p>
      <h2>Information Retention</h2>
      <p className="MsoNormal">
        <u>
          We retain the following personal information for the following periods of
          time:
        </u>
      </p>
      <table
        className="MsoNormalTable"
        border={1}
        cellSpacing={0}
        cellPadding={0}
        width={625}
        style={{ width: "468.4pt", borderCollapse: "collapse", border: "none" }}
      >
        <thead>
          <tr>
            <td
              valign="bottom"
              style={{
                borderTop: "none",
                borderLeft: "solid #DDDDDD 1.0pt",
                borderBottom: "solid #DDDDDD 1.5pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <b>
                  <u>Category of information</u>
                </b>
              </p>
            </td>
            <td
              valign="bottom"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.5pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                <b>
                  <u>Data retention period</u>
                </b>
              </p>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">Identifying information</p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                until we no longer need the information to contact you (this depends
                on customers order date)
              </p>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">Financial information</p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                until we have processed your order. Usually only a few hours.
              </p>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">Internet or other electronic activity</p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">
                12 months
                <span className="msoIns">
                  <ins
                    cite="mailto:Microsoft%20Office%20User"
                    dateTime="2023-08-21T09:10"
                  >
                    {" "}
                  </ins>
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: "solid #DDDDDD 1.0pt",
                borderTop: "none",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">Sensitive personal information</p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "solid #DDDDDD 1.0pt",
                borderRight: "solid #DDDDDD 1.0pt",
                padding: "6.0pt 6.0pt 6.0pt 6.0pt"
              }}
            >
              <p className="MsoNormal">12 months</p>
            </td>
          </tr>
        </tbody>
      </table>

      <h2>Sale of Personal Information</h2>
      <p className="MsoNormal">
        While we do not “sell” your personal information in the standard meaning of
        that term, a &nbsp;broad definition of “sale” may include activities arising
        from common marketing and advertising practices, which allow us to better
        know and serve our customers. For example, the broad definition of “sale”
        includes sharing your data with advertising networks for purposes of
        targeted advertisements. Thus, we may sell your personal information,
        subject to your right to opt-out of those sales (see <a href="/policy-center/data-policy/" target="_blank">Do Not Sell or Share My Personal
        Data</a>).{" "}
      </p>
      <h2>Security</h2>
      <p className="MsoNormal">
        We have implemented safeguards to protect the personal information we
        collect from loss, misuse, and unauthorized access, disclosure, alteration,
        and destruction. Please be aware that despite our best efforts, no data
        security measures can guarantee 100% security. You should take steps to
        protect against unauthorized access to your password, phone, and computer
        by, among other things, signing off after using a shared device.
      </p>
      <h2>Minors</h2>
      <p className="MsoNormal">
        Our Services are not designed for minors under 16. If we discover that a
        minor under 16 has provided us with personal information, we will use that
        information only to respond to that minor to inform them that they cannot
        use this Site, and will then delete such information from our systems.
      </p>
      <h2>Exercising Your Rights</h2>
      <p className="MsoNormal">
        Only you, or someone legally authorized to act on your behalf, may make a
        verifiable consumer request related to your personal information. You may
        also make a verifiable consumer request on behalf of your minor child.{" "}
      </p>
      <p className="MsoNormal">
        To exercise your right: to know, to correct, to limit use and disclosure of
        sensitive personal information, or to request deletion of information,
        please submit a verifiable request using one of the following methods:
      </p>
      <ul style={{ marginTop: "0in" }} type="disc">
        <li className="MsoNormal" style={{ marginBottom: "0in" }}>
          Email:&nbsp;&nbsp;&nbsp;{" "}
          <a href="mailto:cs@piroshkybakery.com">cs@piroshkybakery.com</a>{" "}
        </li>
        <li className="MsoNormal" style={{ marginBottom: "0in" }}>
          Phone: 206-764-1000
        </li>
        <li className="MsoNormal" style={{ marginBottom: "0in" }}>
          Visit our Contact Page at{" "}
          <a href="https://piroshkybakery.com/contacts/">
            Piroshky Piroshky Bakery - Contact
          </a>{" "}
        </li>
      </ul>
      <p
        className="MsoNormal"
        style={{
          marginTop: "0in",
          marginRight: "0in",
          marginBottom: "0in",
          marginLeft: ".25in"
        }}
      >
        &nbsp;
      </p>
      <p className="MsoNormal">
        To exercise your right to opt out of us tracking your location, you can
        adjust the settings on your web browser or device.
      </p>
      <p className="MsoNormal">
        We cannot respond to your request or provide you with personal information
        if we cannot verify your identity or authority to make the request and
        confirm the personal information relates to you. You may only make a
        verifiable consumer request for access or data portability twice within a
        12-month period. We will only use personal information provided in a
        verifiable consumer request to verify the requestor's identity or authority
        to make the request.{" "}
      </p>
      <p className="MsoNormal">
      The verifiable consumer request must:
      </p>
      <p className="MsoListParagraphCxSpFirst" style={{ textIndent: "-.25in" }}>
        <span style={{ fontFamily: "Symbol" }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Provide sufficient information that allows us to reasonably verify you are
        the person about whom we collected personal information or an authorized
        representative, which may include:
      </p>
      <p
        className="MsoListParagraphCxSpMiddle"
        style={{ marginLeft: "1.0in", textIndent: "-.25in" }}
      >
        <span style={{ fontFamily: '"Courier New"' }}>
          o<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;</span>
        </span>
        Name
      </p>
      <p
        className="MsoListParagraphCxSpMiddle"
        style={{ marginLeft: "1.0in", textIndent: "-.25in" }}
      >
        <span style={{ fontFamily: '"Courier New"' }}>
          o<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;</span>
        </span>
        Phone number
      </p>
      <p
        className="MsoListParagraphCxSpLast"
        style={{ marginLeft: "1.0in", textIndent: "-.25in" }}
      >
        <span style={{ fontFamily: '"Courier New"' }}>
          o<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;</span>
        </span>
        Email address
      </p>
      <p className="MsoNormal">
        To submit a request as an authorized agent, you must follow the instructions
        above as well as provide with your request written documentation, such as a
        valid power of attorney or a letter signed by the individual for whom you
        are submitting the request, identifying you as the authorized agent.{" "}
      </p>
      <p className="MsoNormal">
        We endeavor to respond to a verifiable consumer request within forty-five
        (45) days of its receipt. If we require more time, we will inform you of the
        reason and extension period in writing. If you have an account with us, we
        will deliver our written response to that account. If you do not have an
        account with us, we will deliver our written response by mail or
        electronically, at your option. Any disclosures we provide will only cover
        the 12-month period preceding the date we received your verifiable consumer
        request. The response we provide will also explain the reasons we cannot
        comply with a request, if applicable.{" "}
      </p>
      <p className="MsoNormal">
        We do not charge a fee to process or respond to your verifiable consumer
        request unless it is excessive, repetitive, or manifestly unfounded. If we
        determine that the request warrants a fee, we will tell you why we made that
        decision and provide you with a cost estimate before completing your
        request.
      </p>
      <h2>Changes to this Policy</h2>
      <p className="MsoNormal">
        This Policy is current as of the Effective Date set forth above. We may
        change this Policy from time to time, so please be sure to check back
        periodically. We will post any changes to this Policy on our Site. If we
        make any changes to this Policy that materially affect our practices
        regarding the personal information, we have previously collected from you,
        we will endeavor to provide you with notice in advance of such change, such
        as via email or prominent notice on the Site.
      </p>
      <h2>Contact Us</h2>
      <p className="MsoNormal">
        If you have questions about the privacy aspects of our Services or would
        like to make a complaint, please contact us at cs@piroshkybakery.com or 1501
        4th Avenue, Suite 200 Seattle, WA 98101.
      </p>

    </div>
  );
};
